import React from "react";
import PropTypes from "prop-types";
import {SketchPicker} from "react-color";
import {useController} from "react-hook-form";
import {Box, Button, Chip} from "@mui/material";
import {isFunction} from "underscore";
import {usePickerStyles} from "./schemaStyles";

const ColorField = ({name, label, defaultValue, handleReset, isResetting}) => {
  const optionalDefaultValue = defaultValue ? defaultValue : "#FFF";
  const {
    field: {onChange, value, ...inputProps},
  } = useController({
    name,
    defaultValue: optionalDefaultValue,
    rules: {required: false},
  });
  const {classes} = usePickerStyles({color: value});

  return (
    <div className={classes.rootMargin}>
      <input
        type="hidden"
        {...inputProps}
        value={value ?? optionalDefaultValue}
      />
      <div className={classes.containerWidth}>
        {label ?? name}
        <Chip
          className={classes.pickerChip}
          size="small"
          label={value ? "" : "Use Default"}
        />
      </div>
      {isResetting ? null : (
        <SketchPicker
          color={value ?? optionalDefaultValue}
          onChange={(color) => onChange(color.hex)} // add drag or not
          onChangeComplete={(color, event) => onChange(color.hex)}
          disableAlpha
          className={classes.picker}
        />
      )}
      <Box
        className={classes.picker}
        sx={{display: "flow-root", width: "100%"}}
      >
        <Button
          size="small"
          variant="text"
          onClick={() => {
            isFunction(handleReset) && handleReset(name);
          }}
          sx={{float: "right"}}
          id={`reset-${name}`}
        >
          Reset
        </Button>
      </Box>
    </div>
  );
};

ColorField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  handleReset: PropTypes.func,
  isResetting: PropTypes.bool,
};

export default ColorField;
